import { influencer } from '@round/api';
import { getTableMetaHelper } from '@round/ui-kit';
import { Meta as BaseMeta } from 'Modules/Plans/CreatorSearch/components/CreatorExploreTable/helpers';
import { CreatorPoolAccounts } from '../../helpers';

export type Meta = BaseMeta & {
    getCreatorPoolAccounts: (creator: influencer.CreatorSearchResult) => CreatorPoolAccounts;
};

export const getTableMeta = getTableMetaHelper<Meta>();
